import { create } from "zustand";
import {
  WorkflowContainerEmptyI,
  WorkflowContainerEmptyActionI,
  WorkflowI,
  WorkflowActionI,
} from "../../../libs/interfaces";
import { createWorkflowContainerEmptySlice } from "./workflow-container-empty.store";
import { persist } from "zustand/middleware";
import { createWorkflowSlice } from "./workflow.store";

export const useWorkflowStoreEmptyZero = create<
  WorkflowContainerEmptyI &
    WorkflowContainerEmptyActionI &
    WorkflowI &
    WorkflowActionI
>()(
  persist(
    (...a) => ({
      ...createWorkflowSlice(...a),
      ...createWorkflowContainerEmptySlice(...a),
    }),
    {
      name: "workflow-container-empty-puce-0",
    }
  )
);
